export type StoreParameters = {
    url: string;
    appName: string;
    appStoreId: string;
    playStoreId: string;
    appStoreLocale: string;
};

export enum PLATFORM_TYPE {
    CZ_PROD = 'cz.voyo',
    CZ_STAGE = 'cz.voyo.stage.beta',
    SK_PROD = 'sk.voyo',
    SK_STAGE = 'sk.voyo.stage',
    RO_PROD = 'ro.voyo',
    RO_STAGE = 'ro.voyo.stage'
}

export const possibleApps = [
    'cz.voyo',
    'sk.voyo',
    'ro.voyo',
    'cz.voyo.stage.beta',
    'sk.voyo.stage',
    'ro.voyo.stage'
];

const getVoyoStoreParameters = (type?: PLATFORM_TYPE): StoreParameters => {
    switch (type) {
        case PLATFORM_TYPE.CZ_PROD:
            return {
                url: 'cz.voyo',
                appName: 'Voyo.cz',
                appStoreId: '529093783',
                playStoreId: 'net.cme.voyo.cz',
                appStoreLocale: 'cz'
            };
        case PLATFORM_TYPE.SK_PROD:
            return {
                url: 'sk.voyo',
                appName: 'voyo-sk',
                appStoreId: '564759871',
                playStoreId: 'net.cme.voyo.sk',
                appStoreLocale: 'sk'
            };

        case PLATFORM_TYPE.RO_PROD:
            return {
                url: 'ro.voyo',
                appName: 'voyo-ro',
                appStoreId: '544688095',
                playStoreId: 'net.cme.voyo.ro',
                appStoreLocale: 'ro'
            };

        case PLATFORM_TYPE.CZ_STAGE:
            return {
                url: 'cz.voyo.stage.beta',
                appName: 'voyo-cz',
                appStoreId: '529093783',
                playStoreId: 'net.cme.voyo.cz',
                appStoreLocale: 'sk'
            };

        case PLATFORM_TYPE.SK_STAGE:
            return {
                url: 'sk.voyo.stage',
                appName: 'voyo-sk',
                appStoreId: '564759871',
                playStoreId: 'net.cme.voyo.sk',
                appStoreLocale: 'sk'
            };

        case PLATFORM_TYPE.RO_STAGE:
            return {
                url: 'ro.voyo.stage',
                appName: 'voyo-ro',
                appStoreId: '544688095',
                playStoreId: 'net.cme.voyo.ro',
                appStoreLocale: 'ro'
            };
        default:
            console.log('No valid subscription.');
            return {
                url: '',
                appName: '',
                appStoreId: '',
                playStoreId: '',
                appStoreLocale: ''
            };
    }
};

export default getVoyoStoreParameters;
